$(function () {

    $('.jyp__slider--fv').slick({
        autoplay: true,
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        prevArrow: '<button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
        nextArrow: '<button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
        centerMode: true,
        variableWidth: true,
        dots: true
    });

    $('.jyp__slider--collection').not('.slick-initialized').slick({
        autoplay: true,
        infinite: true,
        speed: 800,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
        nextArrow: '<button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
        centerMode: true,
        variableWidth: true,
        initialSlide: 0
    })

    // $('.jyp__new-arrival__countainer .featured__collection-carousel').slick({
    //     autoplay: true,
    //     infinite: true,
    //     speed: 800,
    //     slidesToShow: 5,
    //     slidesToScroll: 1,
    //     prevArrow: '<button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
    //     nextArrow: '<button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    //     centerMode: true,
    //     variableWidth: true,
    //     initialSlide: 0
    // })

    var product_slider = ".product_slider"; // スライダー
    var product_thumbnail = ".product_thumbnail .thumbnail-img"; // サムネイル画像アイテム

    // サムネイル画像アイテムに data-index でindex番号を付与
    $(product_thumbnail).each(function () {
        var index = $(product_thumbnail).index(this);
        $(this).attr("data-index", index);
    });

    $(product_slider).on('init', function (slick) {
        var index = $(".slide-item.slick-slide.slick-current").attr("data-slick-index");
        $(product_thumbnail + '[data-index="' + index + '"]').addClass("thumbnail-current");
    });

    // メイン画像のオプション
    $(".product_slider").not('.slick-initialized').slick({
        autoplay: false, // 自動再生OFF
        arrows: true, // 矢印非表示
        infinite: false,
        fade: true, //フェードする
        prevArrow: '<button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
        nextArrow: '<button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>'
    });

    // サムネイルのオプション
    $(".product_thumbnail").not('.slick-initialized').slick({
        autoplay: false, // 自動再生OFF
        infinite: false,
        // asNavFor: ".product_slider", // メイン画像と同期
        // centerMode: true,
        slidesToShow: 6,
        slidesToScroll:4,
        // variableWidth: true,
        // focusOnSelect: true, // サムネイルクリックを有効化
        arrows: false // 矢印非表示
    });

    //サムネイル画像アイテムをクリックしたときにスライダー切り替え
    $(product_thumbnail).on('click', function () {
        var index = $(this).attr("data-index");
        $(product_slider).slick("slickGoTo", index, false);
    });

    //サムネイル画像のカレントを切り替え
    $(product_slider).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $(product_thumbnail).each(function () {
            $(this).removeClass("thumbnail-current");
        });
        $(product_thumbnail + '[data-index="' + nextSlide + '"]').addClass("thumbnail-current");
    });

    //TOPへ戻るボタン

    $(window).on('load scroll', function () {
        if ($(this).scrollTop() > 200) {
            $('.jyp__scroll__btn').addClass('jyp__scroll__btn--active');
        } else {
            $('.jyp__scroll__btn').removeClass('jyp__scroll__btn--active');
        }
    });

    $('.jyp__scroll__btn').on('click', function () {
        $('body,html').animate({
            scrollTop: 0
        });
    });

    $(window).on('load scroll', function () {
        var height = $(document).height(),
            position = window.innerHeight + $(window).scrollTop(),
            footer = $('.jyp__footer').height();
        if (window.matchMedia('(max-width: 550px)').matches) {
            if (height - position - 72 < footer) {
                $('.jyp__scroll__btn').addClass('jyp__scroll__btn--stop');
            } else {
                $('.jyp__scroll__btn').removeClass('jyp__scroll__btn--stop');
            }
        } else {
            if (height - position - 41 < footer) {
                $('.jyp__scroll__btn').addClass('jyp__scroll__btn--stop');
            } else {
                $('.jyp__scroll__btn').removeClass('jyp__scroll__btn--stop');
            }
        }
    });

    //マウスがホバーしたら今まで表示していたパネルのtabbed__collections-を含むタグを取得
    //その後ホバーされたスライダーを表示（no_visibleを削除）

    $(document).ready(function () {
        $(".jyp__artist__slider").addClass("no_visible");
        $(".jyp__artist__slider:first").removeClass("no_visible");
    });

    max_slide_count = $(".jyp__artist__slider:first").data('collection_image_cnt');
    selectid = $(".jyp__artist__slider:first").data('blockid');
    stop_flg = false;

    $(".jyp__panel__item").hover(function () {
        selectid = $(this).data('blockid');
        elem = $('.jyp__artist__slider[data-blockid="' + selectid + '"]');
        $(".jyp__artist__slider").addClass("no_visible");
        elem.removeClass("no_visible");
        $('.jyp__slider--collection').slick('setPosition');
        $('.jyp__slider--collection').slick('slickGoTo', 0 , true);
        $('.jyp__slider--collection').slick('slickPlay');
        max_slide_count = $('.jyp__artist__slider[data-blockid="' + selectid + '"]').data('collection_image_cnt');
    });

    $('.jyp__slider--collection[data-blockid="' + selectid + '"]').on('afterChange', function (slick, currentSlide) {
        if (stop_flg == true) {
            $('.jyp__slider--collection').slick('slickPause');
            stop_flg = false;
        } else {
            if (max_slide_count < 4) {
                if ($('.jyp__slider--collection[data-blockid="' + selectid + '"]').slick('slickCurrentSlide') === 3) {
                    stop_flg = true;
                }
            } else {
                if ($('.jyp__slider--collection[data-blockid="' + selectid + '"]').slick('slickCurrentSlide') === (max_slide_count- 1)) {
                    stop_flg = true;
                }
            }
        }
    });
});


function slideAnime() {
    $('.downAnime').each(function () {
        var elemPos = $(this).offset().top + 100;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll >= elemPos - windowHeight) {
            // 下から上へ表示するクラスを付与
            // テキスト要素を挟む親要素（下）とテキスト要素を元位置でアニメーションをおこなう
            $(this).addClass("slideAnimeDownUp");
            // 要素を下枠外に移動しCSS アニメーションで下から元の位置に移動
            $(this).children(".downAnimeInner").addClass("slideAnimeUpDown");
            // 子要素は親要素のアニメーションに影響されないように逆の指定をし元の位置をキープするアニメーションをおこなう
        }
    });
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
    slideAnime();/* アニメーション用の関数を呼ぶ*/
});// ここまで画面をスクロールをしたら動かしたい場合の記述

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
    slideAnime();/* アニメーション用の関数を呼ぶ*/
});// ここまで画面が読み込まれたらすぐに動かしたい場合の記述


function popstart() {
    $('.popoutText').each(function () {
        var elemPos = $(this).offset().top + 100;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll >= elemPos - windowHeight) {
            // 下から上へ表示するクラスを付与
            // テキスト要素を挟む親要素（下）とテキスト要素を元位置でアニメーションをおこなう
            $(this).addClass("popoutTextStart");
        }
    });
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
    popstart();
});

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
    popstart();
});


// h3のアニメーション

function passingBarStart() {
    $('.jyp__passing__bar--js').each(function () {
        var elemPos = $(this).offset().top + 100;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll >= elemPos - windowHeight) {
            // 下から上へ表示するクラスを付与
            // テキスト要素を挟む親要素（下）とテキスト要素を元位置でアニメーションをおこなう
            $(this).addClass("jyp__passing__bar");
        }
    });
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
    passingBarStart();
});

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
    passingBarStart();
});

function passingTextStart() {
    $('.jyp__passing__text--js').each(function () {
        var elemPos = $(this).offset().top + 100;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll >= elemPos - windowHeight) {
            // 下から上へ表示するクラスを付与
            // テキスト要素を挟む親要素（下）とテキスト要素を元位置でアニメーションをおこなう
            $(this).addClass("jyp__passing__text");
        }
    });
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
    passingTextStart();
});

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
    passingTextStart();
});

